module.exports = {"id":"188524","name":"Volkan Babacan","rating":"79","photo":"./data/images/photos/1/188524.png","club":{"name":"Medipol Başakşehir","logo":"./data/images/clubs/MedipolBasaksehir.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VolkanBabacan0.json
// module id = 4302
// module chunks = 0